// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VModal from 'vue-js-modal'
import firebase from 'firebase'
import VTooltip from 'v-tooltip'

Vue.config.productionTip = false
Vue.use(VModal, { dialog: true })
Vue.use(VTooltip)

let app = null;

import db from '@/firebase/init'
import moment from "moment";

console.log("LOADING MAIN.JS")

async function setAllBookingsByDateRange() {

  console.log("RUNNING FUNCTION")

  var timestamp = moment.unix(new Date());
  console.log(timestamp)
  // var timestamp = 1603749600000 + (1 * 86400000) + 3600000;
  // console.log(timestamp)
  // var new_timestamp = (timestamp + 3600000)-86400000;

  function roundToLastMidnight(timestamp) {
    // const date = new Date(timestamp - (48 * 3600000));
    const date = new Date(timestamp);
    date.setHours(0, 0, 0, 0); // Set the time to midnight
    return date.getTime();
  }

  var bookings = [];
  //Get data from the firestore
  //get timestamp of 1 january 2025
  var timestamp_1_january_2025 = moment("2025-01-01").startOf("day").valueOf();
  console.log("Timestamp 1 January 2025: " + timestamp_1_january_2025)

  var timestamp_of_26_october_2025 = moment("2025-10-26").startOf("day").valueOf();
  console.log("Timestamp of 26 October 2025: " + timestamp_of_26_october_2025)

  var timestamp_of_31_march_2026 = moment("2026-03-31").startOf("day").valueOf();
  console.log("Timestamp of 31 december 2026: " + timestamp_of_31_march_2026)

  var i = 0;

//   var collection = db.collection('bookings').where("timestamp", ">", timestamp_of_26_october_2025).where("timestamp", "<", timestamp_of_31_march_2026).where("location", "==", "Utrecht Parkeren")

// all future timestamps that have no date_string field yet
  var collection = db.collection('bookings').where("timestamp", ">", timestamp_of_31_march_2026).where("date_string", "==", null)
  const response = await collection.get();

  console.log("Total bookings to be updated: " + response.size)

  response.forEach(async (doc)=> {

      i++
      
      var date_created  = moment(doc.data().created,"MMMM Do YYYY, h:mm:ss a");
      var date_now      = moment(new Date()).subtract(1, 'days');
      var date_noon     = moment(new Date()).set({hour: 12, minute: 0, second: 0, millisecond: 0});

      if(date_created > date_now){

        console.log("Date Created is after date now: " + date_created.format('llll'))
        var date1                 = moment.unix((doc.data().timestamp)/1000).format('llll');
        console.log("this booking takes place at: " + date1);

        if(date_created < date_noon){

          // console.log("======================================")
          // console.log("This booking was created: " + date_created.format('llll'));
          // console.log("this booking was created by: " + doc.data().employee + " at " + doc.data().location);

          // var date1                 = moment.unix((doc.data().timestamp)/1000).format('llll');
          // console.log("this booking takes place at: " + date1);
          
          // var old_timestamp = doc.data().timestamp;
          // var new_timestamp = (doc.data().timestamp + (24 * 3600000));
          // console.log("this booking will be updated to: " + moment.unix(new_timestamp/1000).format('llll'));

          // await db.collection("bookings").doc(doc.id).update({ updated: true, timestamp: new_timestamp, old_timestamp: old_timestamp })

          // var date1                 = moment.unix((doc.data().timestamp)/1000).format("MM/DD/YYYY h:mm:ss a");
          // console.log(doc.data().employee + " at " + doc.data().location);
          // console.log((doc.data().timestamp) + " = " + date1);

        } else {

          // console.log("======================================")
          // console.log("This booking was created: " + date_created.format('llll'));
          // console.log("this booking was created by: " + doc.data().employee + " at " + doc.data().location);

          // var date1                 = moment.unix((doc.data().timestamp)/1000).format('llll');
          // console.log("this booking takes place at: " + date1);
          
          // var old_timestamp = doc.data().timestamp;
          // var new_timestamp = (doc.data().timestamp + (24 * 3600000));
          // console.log("this booking will be updated to: " + moment.unix(new_timestamp/1000).format('llll'));

          // console.log("YES")
          // var date1                 = moment.unix((doc.data().timestamp)/1000).format("MM/DD/YYYY h:mm:ss a");
          // console.log(doc.data().employee + " at " + doc.data().location);
          // console.log((doc.data().timestamp) + " = " + date1);
  
          // console.log(doc.data())
          // var last_midnight = roundToLastMidnight(doc.data().timestamp);
          // console.log("last_midnight is:")
          // console.log(moment.unix(last_midnight/1000).format("MM/DD/YYYY h:mm:ss a"))
          // console.log(last_midnight)
        }
      } else {

        // console.log("======================================")
        // console.log("This booking was created: " + date_created.format('llll'));
        // console.log("this booking was created by: " + doc.data().employee + " at " + doc.data().location);

        // var date1                 = moment.unix((doc.data().timestamp)/1000).format('llll');
        // console.log("this booking takes place at: " + date1);
        
        // var old_timestamp = doc.data().timestamp;
        // var new_timestamp = (doc.data().timestamp + (24 * 3600000));
        // console.log("this booking will be updated to: " + moment.unix(new_timestamp/1000).format('llll'));
    
        if(doc.data().updated27102025 != true){
            // console.log(doc.data())
            // console.log("======================================")
            // console.log("This booking was created: " + date_created.format('llll'));
            // console.log("this booking was created by: " + doc.data().employee + " at " + doc.data().location);

            // var date1                 = moment.unix((doc.data().timestamp)/1000).format('llll');
            // console.log("this booking takes place at: " + date1);
            
            // var old_timestamp = doc.data().timestamp;
            // var new_timestamp = (doc.data().timestamp - (24 * 3600000));
            // console.log("this booking will be updated to: " + moment.unix(new_timestamp/1000).format('llll'));

            // await db.collection("bookings").doc(doc.id).update({ updated27102025: true, timestamp: new_timestamp, old_timestamp: old_timestamp })
            // console.log("UPDATED")
        }
        
        // console.log(doc.data())
        // console.log("NO")
        //GET THE TIME STAMP OF TE APPOINTMENT
        // var date1                 = moment.unix((doc.data().timestamp)/1000).format("MM/DD/YYYY h:mm:ss a");

        // var new_unix              = moment.unix((doc.data().timestamp - (12 * 3600000))/1000)
        // var date2                 = moment.unix(new_unix/1000).format("MM/DD/YYYY h:mm:ss a");

        // var new_unix_one_day      = moment.unix((doc.data().timestamp - (12 * 3600000))/1000)
        // var date3                 = moment.unix(new_unix_one_day/1000).format("MM/DD/YYYY h:mm:ss a");

        if(doc.data().timestamp == 1734350400000){

          // console.log(doc.data().employee + " at " + doc.data().location);
          // console.log((doc.data().timestamp) + " = " + date1);
  
          // console.log("++++++++++")
          // console.log(new_unix + " = " + date2);
          // console.log(new_unix._i);
          // console.log("++++++++++")
          // console.log("==========")
          // console.log(new_unix_one_day + " = " + date3);
          // console.log(new_unix_one_day._i);
          // console.log("==========")
          
          // console.log(doc.data())
          // var last_midnight = roundToLastMidnight(doc.data().timestamp);
          // console.log("last_midnight is:")
          // console.log(moment.unix(last_midnight/1000).format("MM/DD/YYYY h:mm:ss a"))
          // console.log(last_midnight)

          //RUN THIS FUNCTION WHEN THERE IS AN EXTRA HOUR
          // await db.collection("bookings").doc(doc.id).update({ updated: true, timestamp: last_midnight })
          // console.log("UPDATED")
          //RUN THIS FUNCTION WHEN THERE IS AN EXTRA HOUR

        }
        
      }

      // await db.collection("bookings").doc(doc.id).update({ updated: true })
      // var booking = await db.collection("bookings").doc(doc.id).get();
      // console.log(booking.data());
      // let booking = doc.data()
      // booking.id = doc.id
      // bookings.push(booking);

  });
}

// setAllBookingsByDateRange()

async function getAllUsers(){
    var users = [];
    var all_extensions_to_be_replaced = [];
    var all_users_to_be_updated = [];
    //Get data from the firestore
    var collection = db.collection('users')
    const response = await collection.get();
    response.forEach(async (doc)=> {
        let user = doc.data()
        user.id = doc.id
        // console.log(user)
        //get the part before the @ symbol
        // store the username in the user
        // if(!user.oldEmail){
        //     await db.collection("users").doc(doc.id).update({ oldEmail: user.email })
        //     console.log("Updated user: " + user.email + " with oldEmail: " + user.oldEmail)
        // } else {
        //     console.log("User: " + user.email + " already has oldEmail: " + user.oldEmail)
        // }
        // await db.collection("users").doc(doc.id).update({ username: user.username })
        // console.log("Updated user: " + user.email + " with username: " + user.username)

        //check the part after the @ symbol

        // if(user.email.split('@')[1] != "burdd.com" && user.email.split('@')[1] != "nehem.nl" && user.email.split('@')[1] != "inventive.nl" && user.email.split('@')[1] != "inventivenl.nl" && user.email.split('@')[1] != "Nehem.nl" && user.email.split('@')[1] != "burdock.com" && user.email.split('@')[1] != "fagus-pme.nl") {
        //     // console.log("User: " + user.email + " does not have a burdd email address")
        //     var extension = user.email.split('@')[1];
            
        //     if(!all_extensions_to_be_replaced.includes(extension)){
        //         all_extensions_to_be_replaced.push(extension);
        //     }

        //     if(!all_users_to_be_updated.includes(user.email)){
        //         all_users_to_be_updated.push(user.email);
        //     }

        // } else {
        //     console.log("User: " + user.email + " has an email address that should not be changed.")
        // }

        //get all users with email adresses that start with secretariaat- and replace the - for a . 
        if(user.email.startsWith("secretariaat.")) {
            console.log("User: " + user.email + " has an email address that should be updated.")
            // var new_email = user.email.replace("secretariaat-", "secretariaat.");
            // console.log("Updating user: " + user.email + " to " + new_email);
            // await db.collection("users").doc(doc.id).update({ email: new_email, sec_email_updated: true }).then(() => {
            //     console.log("Updated user: " + user.email + " to " + new_email);
            // });
        } else {
            // console.log("User: " + user.email + " does not have an email address that should be updated.")
        }

    });

    console.log("All extensions to be replaced: " + all_extensions_to_be_replaced)
    // console.log("All users to be updated: " + all_users_to_be_updated)

    //positive for loop to update the users
    // for (let i = all_users_to_be_updated.length - 1; i >= 0; i--) {
    // for (let i = 0; i < all_users_to_be_updated.length; i++) {

    //     const user_email        = all_users_to_be_updated[i];
    //     const user_extension    = user_email.split('@')[1];
    //     const new_email         = user_email.replace(user_extension, "pnoinnovation.com");

    //     //check if a user with the new email already exists
    //     const user_exists = await db.collection("users").where("email", "==", new_email).get().then((querySnapshot) => {
    //         return querySnapshot.size > 0;
    //     });

    //     if(user_exists){
    //         console.log("User with email: " + new_email + " already exists. Skipping update for user: " + user_email);
    //         continue;
    //     } else {
    //         console.log("Updating user: " + user_email + " to " + new_email);
    //         await db.collection("users").where("email", "==", user_email).get().then((querySnapshot) => {
    //             querySnapshot.forEach((doc) => {
    //                 db.collection("users").doc(doc.id).update({ email: new_email, email_updated: true }).then(() => {
    //                     console.log("Updated user: " + user_email + " to " + new_email);
    //                 });
    //             });
    //         })
    
        // await db.collection("users").where("email", "==", user_email).get().then((querySnapshot) => {
        //     querySnapshot.forEach((doc) => {
        //         db.collection("users").doc(doc.id).update({ email: new_email })
        //     });
        //     console.log("Updated user: " + user_email + " to " + new_email);
        // });
        
        // }
    
    // }
}

// getAllUsers()

// Wait for firebase auth to init before creating the app
firebase.auth().onAuthStateChanged(()=>{
  //init app if not already created
  if(!app){
    /* eslint-disable no-new */
    app = new Vue({
      el: '#app',
      store,
      router,
      components: { App },
      template: '<App/>'
    })
  }
})




// WEBPACK FOOTER //
// ./src/main.js